module.exports = __webpack_public_path__ + "static/img/head.d6e02e8e.svg";